var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affirm pointer",on:{"click":_vm.showModal}},[_c('span',{staticClass:"affirm-as-low-as",attrs:{"data-amount":_vm.amount,"data-affirm-color":_vm.color,"data-page-type":"payment"}})])}
var staticRenderFns = []

export { render, staticRenderFns }